import { eachDayOfInterval, isWeekend, isValid, parseISO } from 'date-fns';

/**
 * Count the number of working days (Mon–Fri) in the inclusive interval
 * [start, end]. This is a client-side preview only; the backend computes the
 * authoritative `workingDays` value (which may also account for public
 * holidays).
 *
 * @param start - Start date as a Date or YYYY-MM-DD string
 * @param end - End date as a Date or YYYY-MM-DD string
 * @returns Number of weekdays in the range, or 0 when the range is invalid
 */
export const countWorkingDays = (
  start: Date | string | null | undefined,
  end: Date | string | null | undefined,
): number => {
  if (!start || !end) return 0;

  const startDate = typeof start === 'string' ? parseISO(start) : start;
  const endDate = typeof end === 'string' ? parseISO(end) : end;

  if (!isValid(startDate) || !isValid(endDate)) return 0;
  if (endDate < startDate) return 0;

  return eachDayOfInterval({ start: startDate, end: endDate }).filter(
    (day) => !isWeekend(day),
  ).length;
};
